import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { WorkspaceLocation, WorkspaceId } from 'honeygrid-types'

export const locationsQueryKey = (workspaceId?: WorkspaceId) => ['locations', workspaceId] as const

interface LocationsParams {
	workspaceId?: WorkspaceId
}

export const useLocations = ({ workspaceId }: LocationsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<WorkspaceLocation[]>({
		queryKey: locationsQueryKey(workspaceId),
		queryFn: (): Promise<WorkspaceLocation[]> => authFetch(`workspaces/${workspaceId}/locations`),
		enabled: !!workspaceId,
	})
}
